import React from 'react';

import CrehanaLogo from 'crehana-icons/CrehanaLogo';

const Header = () => (
  <div className="pt-16 pb-16 bg-white border-b border-solid border-gray-light">
    <div className="flex items-center ml-auto mr-auto">
      <a href="/" target="_blank" aria-label="Crehana">
        <CrehanaLogo size={20} />
      </a>
    </div>
  </div>
);

export default Header;
